import React, { ChangeEvent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from '../common/Checkbox/Checkbox';
import "./GEV.css";
import { OperationDataClass, OperationFieldProps } from '../../types/assessment_info/gev/BusinessOperationFormProps';
import { useBusinessOperationsState } from '../../utils/context/BusinessOperationsContext';
import { BusinessOperationsKeys, farmingOption } from '../../pages/BusinessOperations/BusinessOperations';
import { FarmingOperationCommercialGrainClass } from '../../types/assessment_info/gev/BusinessOperationsData';

export default function GEVYesNo(props: OperationFieldProps): JSX.Element {
    const { operation, name } = props;
    const { t } = useTranslation('gev')
    const { formData, setFormData } = useBusinessOperationsState();
    const fieldLink: Record<string, string> = {
        "isTruckScaleOnSite": "truckScaleCapacity",
        "areAnyBuildingsAddedOrRemoved": "comments"
    }

    const isTruckScaleOnSiteValue = (formData[operation as BusinessOperationsKeys] as FarmingOperationCommercialGrainClass)['isTruckScaleOnSite'];

    const areAnyBuildingsAddedOrRemovedValue = (formData[operation as BusinessOperationsKeys] as FarmingOperationCommercialGrainClass)['areAnyBuildingsAddedOrRemoved'];
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        props.removeError && (name in fieldLink ? props.removeError(name, fieldLink[name]) : props.removeError(name))
        const { checked, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [operation]: {
                ...prevData[operation as BusinessOperationsKeys],
                [name]: value === 'true' ? checked : !checked
            },
        }));
    };

    useEffect(() => {
        if (operation === farmingOption && !isTruckScaleOnSiteValue) {
            setFormData((prevData) => ({
            ...prevData,
            [operation]: {
                ...prevData[operation as BusinessOperationsKeys],
                'truckScaleCapacity': null
            },
            }));
        }

        if (operation === farmingOption && !areAnyBuildingsAddedOrRemovedValue) {
            setFormData((prevData) => ({
            ...prevData,
            [operation]: {
                ...prevData[operation as BusinessOperationsKeys],
                'comments': null
            },
            }));
        }
    }, [isTruckScaleOnSiteValue, areAnyBuildingsAddedOrRemovedValue, operation, setFormData])
    const currentValue = formData[operation as BusinessOperationsKeys]?.[name as keyof OperationDataClass] ?? '';

    return (
        <tr className='gev-input-tr'>
            <td className='index'>
                {props.index && props.index + "."}
            </td>
            <td>
                <div className='gev-input-label'>{t(operation + "." + name)}</div>
                <fieldset className='noborder-fieldset'  aria-label="grain-elevator-yes-no-checkboxes">
                    <legend className='invisible-legend'><span>{t(operation + "." + name)}</span></legend>
                    <div className='flex flex-row gev-gap'>
                        <div className="gev-yesno">
                            {t("yes")}&nbsp;&nbsp;
                            <Checkbox name={operation + "." + name} value="true"
                                id={`${operation}.${name}.true`}
                                ariaLabel={t(operation + "." + name)}
                                checked={currentValue === true}
                                onChange={handleChange}
                                checkboxclassname={props.hasErrors ? 'form-error' : 'checkmark'}
                            />
                        </div>
                        <div className="gev-yesno">
                            {t("no")}&nbsp;&nbsp;
                            <Checkbox name={operation + "." + name} value="false"
                                checked={currentValue === false}
                                id={`${operation}.${name}.false`}
                                ariaLabel={t(operation + "." + name)}
                                onChange={handleChange}
                                checkboxclassname={props.hasErrors ? 'form-error' : 'checkmark'}
                            />
                        </div>
                    </div>
                </fieldset>
                <div className="input-error-message">
                    {props.errors && props.errors[name] as string}
                </div>
            </td>
        </tr>
    )
}
